import { KeyValuePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    ViewSetting,
    ViewSettingsDefinition,
    ViewSettingsDefinitionType,
} from '@navfleet/client/view-settings/domain/models';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { ButtonModule } from '@openng/optimus-ui/button';
import { CheckboxModule } from '@openng/optimus-ui/checkbox';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { InputNumberModule } from '@openng/optimus-ui/inputnumber';
import { InputTextModule } from '@openng/optimus-ui/inputtext';
import { SelectModule } from '@openng/optimus-ui/select';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
    selector: 'fl-view-settings',
    imports: [
        DialogModule,
        ButtonModule,
        CheckboxModule,
        TranslationModule,
        FormsModule,
        InputNumberModule,
        InputTextModule,
        SelectModule,
        TooltipModule,
        KeyValuePipe,
    ],
    templateUrl: './view-settings.component.html',
    styleUrl: './view-settings.component.scss',
})
export class ViewSettingsComponent {
    public readonly definition = input<ViewSettingsDefinition>();
    public readonly closeDialog = output<void>();
    public readonly apply = output<void>();
    public readonly resetSettings = output<string>();
    public readonly settingChanged = output<{ sectionKey: string; changedKey: string; newValue: boolean }>();

    protected readonly definitionType = ViewSettingsDefinitionType;
    protected readonly originalOrder = (): number => 0;

    public getChildViewSettings(
        allSettings: { [key: string]: ViewSetting | undefined } | undefined,
        parentId: string
    ): { [key: string]: ViewSetting } {
        if (!allSettings) {
            return {};
        }

        return Object.entries(allSettings).reduce(
            (acc, [key, val]) => {
                if (val?.parentId === parentId) {
                    acc[key] = val;
                }
                return acc;
            },
            {} as { [key: string]: ViewSetting }
        );
    }

    public change(sectionKey: string, changedKey: string, newValue: boolean): void {
        this.settingChanged.emit({ sectionKey, changedKey, newValue });
    }
}
